<template>
    <div class="page-content">
        <div class="card">
            <div class="card-header">
                <b-btn
                    variant="info"
                    href="download-authorizations-excel-format"
                    target="_blank"
                    ><i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    Descargar formato excel</b-btn
                >
            </div>
            <div class="card-body">
                <div class="card-text">
                    <app-sub-title
                        text="Cargue de autorizaciones para el cliente"
                    ></app-sub-title>
                    <app-form-select-input
                        label="Estructura"
                        :options="structures"
                        v-model="structureId"
                        :hasError="$v.structureId.$error"
                        errorMessage="Debe seleccionar la estructura a la cual tendran permiso los usuarios autorizados"
                        @change="$v.structureId.$touch()"
                    />
                    <input
                        type="file"
                        name="file"
                        accept=".xlsx"
                        class="file-input"
                        @change="setFile($event.target.files)"
                    />
                    <span v-if="$v.file.$error" class="field-error"
                        >Debe seleccionar un archivo para cargar</span
                    >
                    <div
                        class="file-info water-4 d-flex flex-column"
                        v-if="!!file"
                    >
                        <div class="d-flex flex-row">
                            <div class="shatter-label">Archivo:</div>
                            <div class="shatter-field">{{ file.name }}</div>
                        </div>
                        <div class="d-flex flex-row">
                            <div class="shatter-label">Tamaño:</div>
                            <div class="shatter-field">
                                {{ Math.round(file.size / 1024) }} kb
                            </div>
                        </div>
                    </div>
                    <app-load-authorizations-results
                        v-if="!!result.ready"
                        :authorizations="result.authorizations"
                        :errors="result.errors"
                    />
                </div>
            </div>
            <div class="card-footer">
                <div class="pull-right">
                    <app-loader class="pull-right" v-if="loading"></app-loader>
                    <button class="btn btn-secondary" @click="$router.go(-1)">
                        <i
                            class="fa fa-arrow-left fa-lg"
                            aria-hidden="true"
                        ></i>
                    </button>
                    <button
                        class="btn btn-confirm"
                        :disabled="inProgress"
                        v-if="!loading"
                        @click="uploadAuthorizations"
                    >
                        Cargar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import authorizeRepository from "../../../../repositories/authorize.repository.js";
import Loader from "../../../UI/Complements/Loader.vue";
import LoadAuthorizationsResults from "./LoadAuthorizationsResults.vue";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

export default {
    components: {
        appLoader: Loader,
        appLoadAuthorizationsResults: LoadAuthorizationsResults
    },
    data() {
        return {
            file: '',
            loading: false,
            result: {
                ready: false,
                authorizations: null,
                errors: null
            },
            clientId: '',
            structureId: ''
        };
    },
    computed: {
        ...mapGetters(["structures"])
    },
    validations: {
        file: { required },
        structureId: { required }
    },
    methods: {
        setFile(files) {
            this.$v.file.$touch();
            if (files.length > 0) {
                this.file = files[0];
            }
        },
        uploadAuthorizations() {
            debugger
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            }

            this.$v.$reset();

            const formData = new FormData();
            formData.append("userId", this.user.id);
            formData.append("clientId", this.client.id);
            formData.append("structureId", this.structureId);
            formData.append("file", this.file);

            const ar = { ...authorizeRepository };

            ar.uploadAuthorizationsFromExcel(formData)
                .then(data => {
                    this.loading = false;
                    this.file = "";
                    this.result.authorizations = data.authorizations;
                    this.result.errors = data.errors;
                    this.result.ready = true;

                    !data.errors.length && toastr.success(
                        "Las autorizaciones han sido cargadas satisfactoriamente"
                    );
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al cargar las autorizaciones por favor contacte al administrador"
                    );
                });
        }
    }
};
</script>
